
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import RecoverMainForm from "@/form/recover/recoverMain/recoverMain";
@Component({
  components: {FormGroup}
})
export default class RecoverMain extends Vue {
  @Prop() readonly form!: RecoverMainForm;
}
